import { Controller, ControllerProps, FieldPath, FieldValues } from 'react-hook-form';

import { FormItem, FormItemProps } from './FormItem';

export interface FormItemControlledProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends Omit<FormItemProps, 'children' | 'defaultValue'>,
    ControllerProps<TFieldValues, TName> {}

export const FormItemControlled = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: FormItemControlledProps<TFieldValues, TName>,
) => {
  const { control, name, defaultValue, rules, shouldUnregister, required, render, ...args } = props;

  const controllerProps = {
    control,
    name,
    defaultValue,
    rules,
    shouldUnregister,
  };

  const formItemProps = {
    required,
    ...args,
  };

  return (
    <Controller
      {...controllerProps}
      render={({ field, fieldState, formState }) => {
        return (
          <FormItem
            {...formItemProps}
            required={required === undefined ? !!rules?.required : required}
            error={fieldState.error?.message || formItemProps.error}
          >
            {render({ field, fieldState, formState })}
          </FormItem>
        );
      }}
    />
  );
};
